import { SEO_PAGES as BASE_SEO_PAGES, SEO_PAGE_META as BASE_SEO_PAGE_META } from "./seo-page-all-data.js";

const THALWIL_IMAGE = "/images/thalwil-dojo-group-2026.webp";

export const SEO_PAGES = {
  ...BASE_SEO_PAGES,
  "bjj-thalwil": {
    ...BASE_SEO_PAGES["bjj-thalwil"],
    heroImage: THALWIL_IMAGE,
  },
  "kids-bjj-thalwil": {
    ...BASE_SEO_PAGES["kids-bjj-thalwil"],
    heroImage: THALWIL_IMAGE,
  },
};

export const SEO_PAGE_META = {
  ...BASE_SEO_PAGE_META,
};
